<template>
<about-us-section :section="section" :section-class="sectionClass" :without-heading="true">
  <template slot="content">
    <h1 class="about-us-promo-section-header" v-html="section.title"></h1>
    <div class="about-us-promo-section-description">
      <p v-for="promoItem in promoItems" v-html="promoItem"></p>
    </div>
  </template>
</about-us-section>
</template>

<script>
import Vue from 'vue'
import AboutUsSection from './AboutUsSection'
import HasSectionHighlights from '@/mixins/HasSectionHighlights'

export default Vue.extend({
  props: ['section', 'namespace'],

  mixins: [HasSectionHighlights],

  components: {
    AboutUsSection,
  },

  computed: {
    promoItems() {
      return this.section.content.split("\n")
    },

    sectionClass() {
      return `about-us-promo-section${this.sectionHighlightClasses}`
    },
  },

  methods: {
    getSectionNamespace() {
      return this.namespace
    },
  },
})
</script>

<style lang="less">
.about-us-promo-section {
  @apply flex flex-wrap flex-col items-center justify-center relative;
  height: 50vh;
  padding: 56px 1rem 0 1rem;
  background-position: top !important;
  background-size: cover;

  .about-us-promo-section-header,
  .about-us-promo-section-description {
    @apply text-white;
  }

  .about-us-promo-section-header {
    @apply font-black text-2xl leading-tight mb-2;
  }
}

@screen md {
  .about-us-promo-section {
    .about-us-promo-section-header {
      @apply text-5xl mb-4;
    }

    .about-us-promo-section-description {
      p {
        @apply mb-4 text-xl;

        &:last-child {
          @apply mb-0;
        }
      }
    }
  }
}
</style>
